import FeedbackCard from './FeedbackCard';
import React from 'react';

interface FeedbackData {
  uuid: string;
  accountUuid: string;
  customerUuid: string;
  comment: string;
  feedbackType: string;
  createdAt: string;
  rating: number | null;
  updatedAt: string | null;
}
interface IProps {
  feedbacks: FeedbackData[];
  feedbackInfo: any;
  setFeedbackInfo: any;
}

const ListOfFeedbacks = (props: IProps) => {
  const { feedbacks, feedbackInfo, setFeedbackInfo } = props;
  return (
    <div className="flex flex-col gap-2.5 xl:overflow-y-auto p-2 md:pr-2.5">
      {/* xl:h-[calc(100vh-180px)] */}
      {feedbacks.map((info: FeedbackData, index) => (
        <FeedbackCard
          info={info}
          feedbackInfo={feedbackInfo}
          setFeedbackInfo={setFeedbackInfo}
          key={index}
        />
      ))}
    </div>
  );
};

export default ListOfFeedbacks;
